/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Bundle_Buybundle1Inputs */

const id_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli Bundel`)
};

const ms_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli Bundle`)
};

const da_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Køb Bundle`)
};

const de_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle kaufen`)
};

const en_us2_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Bundle`)
};

const es_es2_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar bundle`)
};

const es_mx2_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar paquete`)
};

const fil_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilhin ang Bundle`)
};

const fr_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter le bundle`)
};

const it_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquista bundle`)
};

const hu_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csomag vásárlása`)
};

const nl_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koop bundel`)
};

const no_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjøp bunt`)
};

const pl_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kup pakiet`)
};

const pt_br2_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Bundle`)
};

const pt_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar pacote`)
};

const ro_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumpără pachetul`)
};

const fi_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osta paketti`)
};

const sv_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köp paket`)
};

const vi_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua gói`)
};

const tr_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketi Satın Al`)
};

const cs_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koupit balíček`)
};

const bg_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купете пакета`)
};

const ru_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купить пакет`)
};

const uk_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купити набір`)
};

const ar_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شراء الحزمة`)
};

const hi_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंडल खरीदें`)
};

const th_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อชุดรวม`)
};

const ja_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バンドルを購入`)
};

const zh_cn2_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Bundle`)
};

const zh_hant1_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Bundle`)
};

const ko_components_bundle_buybundle1 = /** @type {(inputs: Components_Bundle_Buybundle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Bundle`)
};

/**
* | output |
* | --- |
* | "Buy Bundle" |
*
* @param {Components_Bundle_Buybundle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_bundle_buybundle1 = /** @type {((inputs?: Components_Bundle_Buybundle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Bundle_Buybundle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_bundle_buybundle1(inputs)
	if (locale === "ms") return ms_components_bundle_buybundle1(inputs)
	if (locale === "da") return da_components_bundle_buybundle1(inputs)
	if (locale === "de") return de_components_bundle_buybundle1(inputs)
	if (locale === "en-US") return en_us2_components_bundle_buybundle1(inputs)
	if (locale === "es-ES") return es_es2_components_bundle_buybundle1(inputs)
	if (locale === "es-MX") return es_mx2_components_bundle_buybundle1(inputs)
	if (locale === "fil") return fil_components_bundle_buybundle1(inputs)
	if (locale === "fr") return fr_components_bundle_buybundle1(inputs)
	if (locale === "it") return it_components_bundle_buybundle1(inputs)
	if (locale === "hu") return hu_components_bundle_buybundle1(inputs)
	if (locale === "nl") return nl_components_bundle_buybundle1(inputs)
	if (locale === "no") return no_components_bundle_buybundle1(inputs)
	if (locale === "pl") return pl_components_bundle_buybundle1(inputs)
	if (locale === "pt-BR") return pt_br2_components_bundle_buybundle1(inputs)
	if (locale === "pt") return pt_components_bundle_buybundle1(inputs)
	if (locale === "ro") return ro_components_bundle_buybundle1(inputs)
	if (locale === "fi") return fi_components_bundle_buybundle1(inputs)
	if (locale === "sv") return sv_components_bundle_buybundle1(inputs)
	if (locale === "vi") return vi_components_bundle_buybundle1(inputs)
	if (locale === "tr") return tr_components_bundle_buybundle1(inputs)
	if (locale === "cs") return cs_components_bundle_buybundle1(inputs)
	if (locale === "bg") return bg_components_bundle_buybundle1(inputs)
	if (locale === "ru") return ru_components_bundle_buybundle1(inputs)
	if (locale === "uk") return uk_components_bundle_buybundle1(inputs)
	if (locale === "ar") return ar_components_bundle_buybundle1(inputs)
	if (locale === "hi") return hi_components_bundle_buybundle1(inputs)
	if (locale === "th") return th_components_bundle_buybundle1(inputs)
	if (locale === "ja") return ja_components_bundle_buybundle1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_bundle_buybundle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_bundle_buybundle1(inputs)
	return ko_components_bundle_buybundle1(inputs)
});
export { components_bundle_buybundle1 as "components.bundle.buyBundle" }